export default __webpack_public_path__ + "static/media/5.57b66672.PNG";